"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcKeyValidationBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_inline_alert_behavior_1 = require("../../molecules/bc-inline-alert/bc-inline-alert-behavior");
var bc_input_token_behavior_1 = require("../../molecules/bc-input-token/bc-input-token-behavior");
var bc_key_validation_constants_1 = require("./bc-key-validation-constants");
var bc_key_validation_elements_1 = require("./bc-key-validation-elements");
var BcKeyValidationBehavior = (function (_super) {
    __extends(BcKeyValidationBehavior, _super);
    function BcKeyValidationBehavior() {
        var _this = _super.call(this) || this;
        _this.config = null;
        _this.onRequestCode = null;
        _this.onFillInput = null;
        _this.onClose = null;
        _this.onInfoAlertClose = null;
        _this.onNoAttemps = null;
        _this._errorAlertBehavior = null;
        _this._infoAlertBehavior = null;
        _this._remainingAttemps = 0;
        _this._clearButton = null;
        _this._continueButton = null;
        _this._token = '';
        _this._defaultConfig = bc_key_validation_constants_1.BcKeyValidationConstants.DEFAULT_CONFIG;
        _this._dialogContainer = null;
        return _this;
    }
    BcKeyValidationBehavior.setUpAll = function () {
        var ELEMENTS = Array.from(document.querySelectorAll("div[class='".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "']")));
        return ELEMENTS.map(function (element) {
            var BEHAVIOR = new BcKeyValidationBehavior();
            BEHAVIOR.setElement(element);
            BEHAVIOR.setUp();
            return BEHAVIOR;
        });
    };
    BcKeyValidationBehavior.prototype._setUp = function () {
        this._dialogContainer = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-dialog"));
        this.config = this.config ? this.config : this._defaultConfig;
        this._remainingAttemps = this.config.remainingAttemps ? this.config.remainingAttemps : this.config.numberOfAttemps;
        if (this._dialogContainer) {
            if (this.config.tokenType) {
                this._createTokenIllustration();
            }
            else {
                this._createPictogram();
            }
            this._cloneDialogContent();
            this._addContainerStyleClass();
            this._addEventToCloseButton();
            this._createInputToken();
            this._setConfigClearButton();
            this._setConfigContinueButton();
            if (this.config.infoAlert) {
                this._initAlerts();
            }
        }
    };
    BcKeyValidationBehavior.prototype._addEventToCloseButton = function () {
        var _this = this;
        var CLOSE_BUTTON = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-close-button-container .bc-icon"));
        CLOSE_BUTTON.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.close(); });
        CLOSE_BUTTON.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            event.stopPropagation();
            if (event.key === 'Enter' || event.key === ' ') {
                _this.close();
            }
        });
    };
    BcKeyValidationBehavior.prototype._initAlerts = function () {
        var ALERT_ELEMENT = this._createInlineAlert(this.config.infoAlert, { secondary: true, type: 'info' });
        this._infoAlertBehavior = this._initInlineAlert(ALERT_ELEMENT, this.onInfoAlertClose);
    };
    BcKeyValidationBehavior.prototype.open = function () {
        var LINK = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-try-container"));
        LINK === null || LINK === void 0 ? void 0 : LINK.remove();
        this.mySelf.classList.add("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-active"));
        this._validateConfigByInfoAlert();
        this._setConfigNoTimer();
        document.body.style.overflow = 'hidden';
    };
    BcKeyValidationBehavior.prototype._validateConfigByInfoAlert = function () {
        var _a, _b;
        if ((_a = this.config.infoAlert) === null || _a === void 0 ? void 0 : _a.show) {
            (_b = this._infoAlertBehavior) === null || _b === void 0 ? void 0 : _b.open();
        }
        else {
            var ACTION_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-action-container"));
            ACTION_CONTAINER === null || ACTION_CONTAINER === void 0 ? void 0 : ACTION_CONTAINER.setAttribute('style', 'padding-bottom: 0');
            var LINKS_CONTANER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-token-links-container"));
            LINKS_CONTANER === null || LINKS_CONTANER === void 0 ? void 0 : LINKS_CONTANER.classList.add('bc-mt-4');
        }
    };
    BcKeyValidationBehavior.prototype._setConfigNoTimer = function () {
        if (!this.config.hideTimer) {
            this._createTimer();
        }
        else {
            var TIMER_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-timeout-container"));
            TIMER_CONTAINER === null || TIMER_CONTAINER === void 0 ? void 0 : TIMER_CONTAINER.remove();
            var INPUT_TOKEN_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-content"));
            INPUT_TOKEN_CONTAINER === null || INPUT_TOKEN_CONTAINER === void 0 ? void 0 : INPUT_TOKEN_CONTAINER.classList.add('bc-pb-0');
            var DESCRIPTION = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-description"));
            DESCRIPTION === null || DESCRIPTION === void 0 ? void 0 : DESCRIPTION.setAttribute('style', 'padding-bottom: 0');
        }
    };
    BcKeyValidationBehavior.prototype.close = function () {
        var _this = this;
        clearInterval(this._intervalTimer);
        this.mySelf.classList.add("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-closing"));
        setTimeout(function () {
            _this.mySelf.classList.remove("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-closing"));
            _this.mySelf.classList.remove("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-active"));
            _this.onClose();
        }, bc_key_validation_constants_1.BcKeyValidationConstants.TIMEOUT_REMOVE_CLASSES);
        if (this.config.resetOnClose) {
            this._resetDOMContent();
        }
        document.body.style.overflow = 'auto';
        this._infoAlertBehavior = null;
        this._errorAlertBehavior = null;
        this._inError = false;
        this._isInvalid = false;
    };
    BcKeyValidationBehavior.prototype._createInlineAlert = function (config, style) {
        var ALERT_ELEMENT = bc_key_validation_elements_1.BcKeyValidationElements.createInlineAlert(style, config);
        ALERT_ELEMENT.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.ALERT_INLINE_TEXT_CLASS)).innerHTML = config.description;
        this._insertInlineAlert(style, ALERT_ELEMENT);
        return ALERT_ELEMENT;
    };
    BcKeyValidationBehavior.prototype._insertInlineAlert = function (style, alertElement) {
        if (style.type === 'error') {
            var INPUT_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-content"));
            INPUT_CONTAINER === null || INPUT_CONTAINER === void 0 ? void 0 : INPUT_CONTAINER.insertAdjacentElement('afterend', alertElement);
        }
        else {
            var ACTIONS_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-action-container"));
            ACTIONS_CONTAINER === null || ACTIONS_CONTAINER === void 0 ? void 0 : ACTIONS_CONTAINER.insertAdjacentElement('afterend', alertElement);
        }
    };
    BcKeyValidationBehavior.prototype._initInlineAlert = function (element, callBack) {
        var INLINE_ALERT = new bc_inline_alert_behavior_1.BcInlineAlertBehavior();
        INLINE_ALERT.setElement(element);
        INLINE_ALERT.onClose(callBack);
        INLINE_ALERT.setUp();
        return INLINE_ALERT;
    };
    BcKeyValidationBehavior.prototype._initInputToken = function () {
        var _this = this;
        var INPUT_TOKEN = new bc_input_token_behavior_1.BcInputTokenBehavior();
        INPUT_TOKEN.setElement(this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.INPUT_TOKEN_CLASS)));
        INPUT_TOKEN.setUp();
        INPUT_TOKEN.outputValue = function (value) {
            _this._token = value;
        };
        this._validateInputFilled();
        return INPUT_TOKEN;
    };
    BcKeyValidationBehavior.prototype._createTimer = function () {
        var TIMER_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-timeout-container"));
        TIMER_CONTAINER === null || TIMER_CONTAINER === void 0 ? void 0 : TIMER_CONTAINER.insertAdjacentElement('beforeend', (0, helpers_1.createElement)({ element: 'h5', props: { id: bc_key_validation_constants_1.BcKeyValidationConstants.TIMER_ID } }));
        this._initCountDown();
    };
    BcKeyValidationBehavior.prototype._initCountDown = function () {
        var _this = this;
        var TOTAL_SECONDS = this.config.timeout;
        var minutes = Math.trunc(TOTAL_SECONDS / bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_60);
        var remainingSeconds = TOTAL_SECONDS % bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_60;
        var setValue = function () {
            _this._updateTimerLabel(minutes, remainingSeconds);
        };
        setValue();
        var seconds = this.config.timeout - 1;
        var secondPassed = function () {
            minutes = Math.trunc(seconds / bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_60);
            remainingSeconds = seconds % bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_60;
            setValue();
            if (seconds === 0) {
                clearInterval(_this._intervalTimer);
                if (_this._remainingAttemps === 1) {
                    _this.onNoAttemps();
                }
                _this._expired = true;
                _this._createGetCodeLink();
                _this._isInvalid = false;
                _this._createInputToken('disabled');
                _this._openErrorAlert({ title: _this.config.expiredTitle, message: _this.config.expiredMessage });
                _this._disableClearButton();
                _this._continueButton.setAttribute('disabled', 'true');
            }
            else {
                seconds--;
            }
        };
        this._intervalTimer = setInterval(secondPassed, bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_1000);
    };
    BcKeyValidationBehavior.prototype._updateTimerLabel = function (minutes, remainingSeconds) {
        var TIMER = this.mySelf.querySelector("#".concat(bc_key_validation_constants_1.BcKeyValidationConstants.TIMER_ID));
        if (TIMER) {
            TIMER.innerHTML = "".concat(minutes < bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_10 ? '0' : '').concat(minutes, ":").concat(remainingSeconds < bc_key_validation_constants_1.BcKeyValidationConstants.NUMBER_10 ? '0' : '').concat(remainingSeconds, " s");
        }
    };
    BcKeyValidationBehavior.prototype._createGetCodeLink = function () {
        var _this = this;
        var _a;
        var LINK_CONTAINER = bc_key_validation_elements_1.BcKeyValidationElements.createGetCodeLink(this.config);
        (_a = LINK_CONTAINER.querySelector('a')) === null || _a === void 0 ? void 0 : _a.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            event.preventDefault();
            _this._toggleLoadingStatus(true);
            if (!_this._inError) {
                _this._remainingAttemps--;
            }
            LINK_CONTAINER.remove();
            _this.onRequestCode({ remainingAttemps: _this._remainingAttemps });
        });
        if (this._remainingAttemps > 1) {
            var INPUT_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container"));
            INPUT_CONTAINER === null || INPUT_CONTAINER === void 0 ? void 0 : INPUT_CONTAINER.insertAdjacentElement('afterend', LINK_CONTAINER);
        }
    };
    BcKeyValidationBehavior.prototype._removeInputToken = function () {
        var INPUT_TOKEN = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container"));
        INPUT_TOKEN === null || INPUT_TOKEN === void 0 ? void 0 : INPUT_TOKEN.remove();
    };
    BcKeyValidationBehavior.prototype._createInputToken = function (_status) {
        this._removeInputToken();
        var status = this._isInvalid ? 'error' : _status;
        var currentAttemp = this.config.numberOfAttemps - (this._remainingAttemps - 1);
        if (this._remainingAttemps === 0) {
            status = 'disabled';
            currentAttemp = this.config.numberOfAttemps;
        }
        var INPUT_TOKEN = bc_key_validation_elements_1.BcKeyValidationElements.createInputToken(this.config, status, currentAttemp, this._formatAttempsLabel.bind(this));
        var TRY_CONTAINER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-try-container"));
        if (TRY_CONTAINER) {
            TRY_CONTAINER.insertAdjacentElement('beforebegin', INPUT_TOKEN);
        }
        else {
            var MODAL_BODY = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-body"));
            MODAL_BODY === null || MODAL_BODY === void 0 ? void 0 : MODAL_BODY.insertAdjacentElement('beforeend', INPUT_TOKEN);
        }
        this._initInputToken();
    };
    BcKeyValidationBehavior.prototype._formatAttempsLabel = function (current) {
        var attempLabel = this.config.attempsLabel;
        attempLabel = attempLabel.replace('{{current}}', String(current));
        attempLabel = attempLabel.replace('{{total}}', String(this.config.numberOfAttemps));
        return attempLabel;
    };
    BcKeyValidationBehavior.prototype._validateInputFilled = function () {
        var _this = this;
        var INPUT_TOKEN = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.INPUT_TOKEN_CLASS));
        var INPUTS = INPUT_TOKEN.querySelectorAll('.bc-input');
        var inputsFilled = 0;
        INPUTS.forEach(function (input) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function () {
                var _a, _b;
                inputsFilled = 0;
                _this._continueButton.setAttribute('disabled', 'true');
                (_a = _this._errorAlertBehavior) === null || _a === void 0 ? void 0 : _a.close();
                if (input.className.indexOf('filled') !== -1) {
                    (_b = _this._clearButton) === null || _b === void 0 ? void 0 : _b.removeAttribute('disabled');
                }
                getNumberOfFilleds();
                if (!inputsFilled) {
                    _this._disableClearButton();
                }
                if (inputsFilled === _this.config.numberOfDigits) {
                    _this._continueButton.removeAttribute('disabled');
                }
                INPUT_TOKEN.removeAttribute('status');
            });
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
                var _a;
                (_a = _this._errorAlertBehavior) === null || _a === void 0 ? void 0 : _a.close();
            });
        });
        var getNumberOfFilleds = function () {
            for (var _i = 0, _a = (0, helpers_1.toArray)(INPUTS); _i < _a.length; _i++) {
                var input = _a[_i];
                if (input['value'] !== '') {
                    inputsFilled++;
                }
            }
        };
    };
    BcKeyValidationBehavior.prototype._setConfigClearButton = function () {
        var _this = this;
        this._clearButton = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-action-container .bc-clear-button"));
        this._disableClearButton();
        this._clearButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var _a;
            _this._createInputToken();
            _this._disableClearButton();
            (_a = _this._continueButton) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'true');
        });
    };
    BcKeyValidationBehavior.prototype._disableClearButton = function () {
        var _a;
        return (_a = this._clearButton) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'true');
    };
    BcKeyValidationBehavior.prototype._setConfigContinueButton = function () {
        var _this = this;
        this._continueButton = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-action-container .bc-continue-button"));
        var disableButton = function () { var _a; return (_a = _this._continueButton) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'true'); };
        disableButton();
        this._continueButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this._toggleLoadingStatus(true);
            _this.onFillInput({ token: _this._token, remainingAttemps: _this._remainingAttemps - 1 });
            if (_this._remainingAttemps - 1 === 0) {
                _this.onNoAttemps();
            }
            disableButton();
        });
    };
    BcKeyValidationBehavior.prototype.updateStatus = function (data) {
        if (data) {
            this._inError = data.status === 'error';
            this._isInvalid = data.status === 'invalid';
            if (data.remainingAttemps) {
                this._remainingAttemps = data.remainingAttemps;
            }
            if (this._isInvalid) {
                this._remainingAttemps--;
                this._createInputToken();
                this._disableClearButton();
                this._openErrorAlert(data.invalidAlert);
            }
            else {
                this._createInputToken();
            }
            if (this._inError) {
                this._updateStatusWithError();
            }
        }
        else {
            this._createInputToken();
            this._initCountDown();
        }
        this._toggleLoadingStatus(false);
    };
    BcKeyValidationBehavior.prototype._updateStatusWithError = function () {
        if (this._expired) {
            this._createInputToken('disabled');
            this._createGetCodeLink();
            this._openErrorAlert({ title: this.config.expiredTitle, message: this.config.expiredMessage });
        }
        else {
            this._expired = false;
            this._createInputToken();
            this._initCountDown();
            this._openErrorAlert();
        }
    };
    BcKeyValidationBehavior.prototype._openErrorAlert = function (invalidAlert) {
        if (this._inError || this._isInvalid || this._expired) {
            var INPUT_CONTAINER_1 = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container"));
            if (this.config.inputErrorAlert) {
                var ALERT_ELEMENT = this._createInlineAlert(this.config.inputErrorAlert, { secondary: false, type: 'error' });
                this._errorAlertBehavior = this._initInlineAlert(ALERT_ELEMENT, function () {
                    INPUT_CONTAINER_1 === null || INPUT_CONTAINER_1 === void 0 ? void 0 : INPUT_CONTAINER_1.classList.remove("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container-with-alert"));
                });
            }
            if (this._isInvalid || this._expired) {
                this._updateErrorAlertData(invalidAlert);
            }
            INPUT_CONTAINER_1.classList.add("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container-with-alert"));
            this._errorAlertBehavior.open();
        }
    };
    BcKeyValidationBehavior.prototype._updateErrorAlertData = function (data) {
        var ERROR_ALERT = this.mySelf.querySelector("#".concat(this.config.inputErrorAlert.elementId));
        ERROR_ALERT.querySelector('.bc-inline-alert-title').textContent = data.title;
        ERROR_ALERT.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.ALERT_INLINE_TEXT_CLASS)).textContent = data.message;
    };
    BcKeyValidationBehavior.prototype._addContainerStyleClass = function () {
        if (this._dialogContainer) {
            this._dialogContainer.className += ' bc-border-radius-3-full bc-card-container bc-shadow-06';
        }
    };
    BcKeyValidationBehavior.prototype._resetDOMContent = function () {
        this._removeDialogContent();
        this._insertClone();
        this._setUp();
    };
    BcKeyValidationBehavior.prototype._cloneDialogContent = function () {
        var _a;
        this._dialogClone = (_a = this._dialogContainer) === null || _a === void 0 ? void 0 : _a.cloneNode(true);
    };
    BcKeyValidationBehavior.prototype._removeDialogContent = function () {
        this._dialogContainer.remove();
    };
    BcKeyValidationBehavior.prototype._insertClone = function () {
        var ARTICLE = document.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS));
        var BEFORE_ELEMENT = ARTICLE === null || ARTICLE === void 0 ? void 0 : ARTICLE.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-dialog"));
        ARTICLE === null || ARTICLE === void 0 ? void 0 : ARTICLE.insertBefore(this._dialogClone, BEFORE_ELEMENT);
    };
    BcKeyValidationBehavior.prototype._createLoadingContainer = function () {
        var LOADING_ELEMENT = bc_key_validation_elements_1.BcKeyValidationElements.createLoading(this.config);
        this._dialogContainer.appendChild(LOADING_ELEMENT);
    };
    BcKeyValidationBehavior.prototype._toggleLoadingStatus = function (loading) {
        var DIALOG_CONTENT = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-content"));
        var CLOSE_ICON = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-close-button-container"));
        if (loading) {
            this._createLoadingContainer();
            this._dialogContainer.classList.add("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-dialog-loading"));
            DIALOG_CONTENT === null || DIALOG_CONTENT === void 0 ? void 0 : DIALOG_CONTENT.classList.add(bc_key_validation_constants_1.BcKeyValidationConstants.HIDDEN_CLASS);
            CLOSE_ICON === null || CLOSE_ICON === void 0 ? void 0 : CLOSE_ICON.classList.add(bc_key_validation_constants_1.BcKeyValidationConstants.HIDDEN_CLASS);
        }
        else {
            this._dialogContainer.classList.remove("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-dialog-loading"));
            DIALOG_CONTENT === null || DIALOG_CONTENT === void 0 ? void 0 : DIALOG_CONTENT.classList.remove(bc_key_validation_constants_1.BcKeyValidationConstants.HIDDEN_CLASS);
            CLOSE_ICON === null || CLOSE_ICON === void 0 ? void 0 : CLOSE_ICON.classList.remove(bc_key_validation_constants_1.BcKeyValidationConstants.HIDDEN_CLASS);
            var LOADING = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-content-loading"));
            LOADING === null || LOADING === void 0 ? void 0 : LOADING.remove();
        }
    };
    BcKeyValidationBehavior.prototype._createPictogram = function () {
        var IMG_ELEMENT = (0, helpers_1.createElement)({
            element: 'img',
            props: {
                src: 'https://library-sdb.apps.bancolombia.com/bds/6.35.0/assets/icons/pictograms/seguridad-88.svg',
            },
            classList: ['bc-pictogram'],
        });
        var HEADER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-header"));
        var TITLE = this.mySelf.querySelector('h3');
        HEADER === null || HEADER === void 0 ? void 0 : HEADER.insertBefore(IMG_ELEMENT, TITLE);
    };
    BcKeyValidationBehavior.prototype._createTokenIllustration = function (updateIcon) {
        var IS_DARK = this._validateDarkTheme();
        var illustrationName = 'softoken';
        var CLASS_LIST = ["".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-token-container")];
        if (this.config.tokenType === 'hard') {
            CLASS_LIST.push("".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-hard-token"));
            illustrationName = 'hardtoken';
        }
        if (IS_DARK) {
            illustrationName += '-2';
        }
        var HEADER = this.mySelf.querySelector(".".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-header"));
        var IMG_PATH = "https://library-sdb.apps.bancolombia.com/bds/6.35.0/assets/icons/illustrations/il-".concat(illustrationName, ".svg");
        if (!updateIcon) {
            var ILLUSTRATION = bc_key_validation_elements_1.BcKeyValidationElements.createIllustration(IMG_PATH, CLASS_LIST);
            var TITLE = this.mySelf.querySelector('h3');
            HEADER === null || HEADER === void 0 ? void 0 : HEADER.insertBefore(ILLUSTRATION, TITLE);
        }
        else {
            var IMG = HEADER.querySelector('img');
            IMG === null || IMG === void 0 ? void 0 : IMG.setAttribute('src', IMG_PATH);
        }
    };
    BcKeyValidationBehavior.prototype._validateDarkTheme = function () {
        var DARK_THEME_STYLE = document.head.querySelector('style[src*="bds-black.min.css"]');
        var DARK_THEME_LINK = document.head.querySelector('link[href*="bds-black.min.css"]');
        return DARK_THEME_STYLE !== null || DARK_THEME_LINK !== null;
    };
    BcKeyValidationBehavior.prototype.changeTheme = function () {
        if (this.config.tokenType) {
            this._createTokenIllustration(true);
        }
    };
    return BcKeyValidationBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcKeyValidationBehavior = BcKeyValidationBehavior;
